import { CompletionStatuses } from '../../../constants';
export const aiSearchEngineOptimizationAudit = () => {
  // we use the component to fetch the data and display the recommendations
  return {
    status: CompletionStatuses.INCOMPLETE
  };
};